"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleLoader = void 0;
var idle_loader_1 = require("@tencent/idle-loader");
var dispose_tree_1 = require("@tencent/dispose-tree");
var instantiation_1 = require("./instantiation");
var loader_base_1 = require("./loader-base");
var async_lock_1 = require("./async-lock");
/**
 * 闲时异步模块加载器，用于将同步依赖转换为闲时依赖
 */
var IdleLoader = /** @class */ (function (_super) {
    __extends(IdleLoader, _super);
    function IdleLoader(params, instantiationService) {
        if (params === void 0) { params = []; }
        var _this = _super.call(this, instantiationService) || this;
        _this.disposableId = 'IdleLoader'; // 清理ID
        _this.params = loader_base_1.paramsToArray(params);
        // 设置闲时执行
        _this.task = idle_loader_1.scheduler.scheduleTask(function () {
            // 每次异步任务都生成新的token，用于标记任务的状态
            var tokenSource = new dispose_tree_1.CancellationTokenSource();
            _this.tokenSource = tokenSource;
            _this.schedulePromise = _this.executor(tokenSource.token);
        });
        return _this;
    }
    IdleLoader.prototype.getInstance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var instance, tokenSource;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.schedulePromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.schedulePromise];
                    case 1:
                        instance = _a.sent();
                        return [2 /*return*/, instance];
                    case 2:
                        // 取消未调度的任务
                        if (this.task) {
                            idle_loader_1.scheduler.cancelTask(this.task);
                            this.task = undefined;
                        }
                        // 已加载但未完成，等待promise完成
                        if (this.getInstancePromise) {
                            return [2 /*return*/, this.getInstancePromise];
                        }
                        tokenSource = new dispose_tree_1.CancellationTokenSource();
                        this.tokenSource = tokenSource;
                        this.getInstancePromise = this.executor(tokenSource.token);
                        return [2 /*return*/, this.getInstancePromise];
                }
            });
        });
    };
    Object.defineProperty(IdleLoader.prototype, "loadedModule", {
        get: function () {
            var _a;
            if ((_a = this.loadBarrier) === null || _a === void 0 ? void 0 : _a.isOpen()) {
                return this.ctor;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    IdleLoader.prototype.dispose = function (trace) {
        var _a;
        _super.prototype.dispose.call(this, trace);
        // 任务已经调度,取消已经调度的异步逻辑任务
        (_a = this.tokenSource) === null || _a === void 0 ? void 0 : _a.cancel();
        this.tokenSource = undefined;
        this.schedulePromise = undefined;
        // 取消任务本身
        if (this.task) {
            // 取消已经调度的任务
            idle_loader_1.scheduler.cancelTask(this.task);
            this.task = undefined;
        }
    };
    IdleLoader.prototype.executor = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var ctor, allParams, instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadModule()];
                    case 1:
                        ctor = _a.sent();
                        if (token.isCancellationRequested || !ctor) {
                            return [2 /*return*/];
                        }
                        allParams = this.params.length > 0 ? this.params : [];
                        instance = this.createInstance(ctor, allParams);
                        return [2 /*return*/, instance];
                }
            });
        });
    };
    /**
     * 加载模块
     */
    IdleLoader.prototype.loadModule = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var module_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 已经加载完成
                        if (((_a = this.loadBarrier) === null || _a === void 0 ? void 0 : _a.isOpen()) && this.ctor) {
                            return [2 /*return*/, this.ctor];
                        }
                        if (!!this.loadBarrier) return [3 /*break*/, 2];
                        // 开始加载流程
                        this.loadBarrier = new async_lock_1.AsyncLock();
                        return [4 /*yield*/, this.getModule()];
                    case 1:
                        module_1 = _b.sent();
                        this.ctor = (module_1 === null || module_1 === void 0 ? void 0 : module_1.default) || module_1;
                        this.loadBarrier.open();
                        return [3 /*break*/, 4];
                    case 2: 
                    // 等待已经启动的加载流程
                    return [4 /*yield*/, this.loadBarrier.wait()];
                    case 3:
                        // 等待已经启动的加载流程
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        if (this.ctor) {
                            return [2 /*return*/, this.ctor];
                        }
                        return [2 /*return*/, undefined];
                }
            });
        });
    };
    IdleLoader = __decorate([
        __param(1, instantiation_1.IInstantiationService)
    ], IdleLoader);
    return IdleLoader;
}(loader_base_1.LoaderBase));
exports.IdleLoader = IdleLoader;
//# sourceMappingURL=idle-loader.js.map